export const MessageError: any = {
  booking: {
    BOK_ERR_006: "Action failed. Slot unavailable.",
    BOK_ERR_007: "Slot unavailable. Please make a new booking.",
  },
  buyer: {
    BUY_ERR_002: "A buyer with this name and address already exists.",
    BUY_ERR_003: "This buyer is currently assigned to one or more producers and cannot be deleted.",
    BUY_ERR_004: "At least one default Buyer is required. To change the default value, select another Buyer and mark it as default.",
    NOT_FOUND: "Buyer has been deleted or not found.",
  },
  haulier: {
    HAU_ERR_002: "A haulier with this name and address already exists.",
    HAU_ERR_003: "This haulier is currently assigned to one or more producers and cannot be deleted.",
    HAU_ERR_004: "At least one default Haulier is required. To change the default value, select another Haulier and mark it as default.",
    NOT_FOUND: "Haulier has been deleted or not found.",
  },
  matrix: {
    NOT_FOUND: "Matrix has been deleted or not found.",

  },
  defaultBuyerHaulierMatrix: {
    BOK_ERR_002: "Action failed.",
  },
  PRI_ERR_018: "Item has been deleted or not found.",
  default: "Action failed. Please try again.",
};
export const MessageSuccess: any = {
  buyer: {
    created: "Buyer created successfully.",
    updated: "Buyer updated successfully.",
  },
  haulier: {
    created: "Haulier created successfully.",
    updated: "Haulier updated successfully.",
    deleted: "Haulier deleted.",
  },
  matrix: {
    created: "Matrix created successfully.",
    updated: "Matrix updated successfully.",
    deleted: "Matrix deleted.",
  },
  lotDetail: {
    success: "Lot updated successfully."
  },
  defaultUpdateSuccess: "Update Success",
  defaultCopySuccess: "Copy Success",
};
